<div class="w-full bg-card">
    <div class="bg-card flex flex-0 flex-col border-b p-4 dark:bg-transparent sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-4 "
    >
        <div class="flex items-end w-full">
            <arrow-back></arrow-back>
            <h2 class="truncate text-3xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">
                Video Tutoriales
            </h2>  
        </div>
    </div>
    <div>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="Administrador">
                <video-grid [videos]="videosAdministrador"></video-grid>
            </mat-tab>

            <mat-tab label="Solicitudes">
                <video-grid [videos]="videosSolicitudes"></video-grid>
            </mat-tab>

            <mat-tab label="Gestiones">
                <video-grid [videos]="videosGestiones"></video-grid>
            </mat-tab>

            <mat-tab label="Bienes Culturales">
                <video-grid [videos]="videosBienesCulturales"></video-grid>
            </mat-tab>

            <mat-tab label="Documentos Oficiales">
                <video-grid [videos]="videosDocumentosOficiales"></video-grid>
            </mat-tab>

            <mat-tab label="Reportes">
                <video-grid [videos]="videosReportes"></video-grid>
            </mat-tab>
        </mat-tab-group>
    </div>

</div>
